export const translationsPath =
  "page.4uSalesContract.registers.baseContracts.advantagesAndBenefitsClub.";

export const buildTPath = (field: string) => `${translationsPath}${field}`;
